<script>
    /**
     * zeluslugi.ru
     * @author      delphinpro <delphinpro@gmail.com>
     * @copyright   copyright © 2018 delphinpro
     * @license     licensed under the MIT license
     */

    import CalcTooltip from './CalcTooltip';

    export default {
        name: "calc-radio-control",

        components: {
            CalcTooltip,
        },

        props: {
            title        : {type: String, default: ''},
            tooltip      : {type: [String, Boolean], default: false},
            options      : {type: Array, default: []},
            value        : [String, Number],
            displayInline: {type: Boolean, default: false},
            disabled     : Boolean,
        },

        data: () => ({}),

        computed: {
            picked: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
        },

        methods: {
            uniqueId() {
                return `calc-radio-control-${this._uid}`;
            },
        },
    };
</script>

<template>
  <div class="calc__group" style="margin-left: 5px;"
       v-if="this.options.length > 0"
  >
    <div class="calc__label"
         :class="{calc__label_disabled:disabled}"
         v-if="title"
    >
      <label class="calc__form-label form-label">{{title}}</label>
      <calc-tooltip
          v-if="tooltip"
          :content="tooltip"
      ></calc-tooltip>
    </div>

    <div class="calc__control calc__control_radio-button"
         :class="{'radio-inline':displayInline}"
    >

      <div class="radio"
           :class="{disabled:disabled}"
           style="margin-bottom: 5px;"
           v-for="(item, index) in options"
      >
        <input class="radio__element"
               type="radio"
               v-model="picked"
               :value="item.value"
               :name="uniqueId()"
               :id="uniqueId() + '-' +index"
        >
        <label class="radio__indicator" :for="uniqueId() + '-' +index"></label>
        <label class="radio__label" :for="uniqueId() + '-' +index"
               style="padding-left: 0.9em;">{{item.title}}</label>

        <calc-tooltip
            v-if="item.tooltip"
            :content="item.tooltip"
        ></calc-tooltip>
      </div>
    </div>
  </div> <!-- // Поддержка 1С -->
</template>
